import Cookies from "js-cookie";

/**
 * Sets a cookie used in the website to show you the "Go to my account" button
 */
export const setWebsiteEmailCookie = (email: string, domain: string): void => {
  Cookies.set("logged_email", email, { domain: getCookieDomain(domain) });
};

export const removeWebsiteEmailCookie = (domain: string): void => {
  Cookies.remove("logged_email", { domain: getCookieDomain(domain) });
};

const getCookieDomain = (domain): string => {
  if (domain.includes("localokrs.com")) {
    return "localokrs.com";
  } else if (domain.includes("staging.gtmhub.com")) {
    return "staging.gtmhub.com";
  }

  return "gtmhub.com";
};
